const normalizeRecipients = (toEmail) => {
  if (Array.isArray(toEmail)) {
    return toEmail.map((item) => String(item).trim()).filter(Boolean);
  }
  return String(toEmail || '')
    .split(',')
    .map((item) => item.trim())
    .filter(Boolean);
};

const findLandlordIdByEmail = (email, inviteLandlords = []) => {
  const normalized = email.toLowerCase();
  const match = inviteLandlords.find(
    (landlord) => String(landlord?.email_address || '').toLowerCase() === normalized,
  );
  return match?.sf_landlord_id || null;
};

/**
 * Builds landlord-invite payload with landlordID aligned 1:1 to toEmail (prod uses sf_landlord_id).
 */
export const buildLandlordInvitePayload = ({
  toEmail,
  emailSubject,
  emailContent,
  landlordID = [],
  inviteLandlords = [],
}) => {
  const recipients = normalizeRecipients(toEmail);
  if (!recipients.length) {
    return { error: 'Enter at least one recipient email.' };
  }

  const explicitIds = Array.isArray(landlordID) ? landlordID : [landlordID];
  const hasExplicitIds =
    explicitIds.length === recipients.length && explicitIds.every((id) => id != null && id !== '');

  const resolvedIds = hasExplicitIds
    ? explicitIds
    : recipients.map((email) => findLandlordIdByEmail(email, inviteLandlords));

  const missingIndex = resolvedIds.findIndex((id) => !id);
  if (missingIndex !== -1) {
    return {
      error:
        'Each recipient must match an operator on the Operator Invite list. Use Operator Invite or select operators before sending.',
      missingEmail: recipients[missingIndex],
    };
  }

  return {
    payload: {
      userRole: 'll',
      toEmail: recipients,
      emailSubject,
      emailContent,
      landlordID: resolvedIds,
    },
  };
};
